export default (() => {
  'use strict';

  const placeholderDiv = document.getElementById("tableauViz");

  if (placeholderDiv === null) {
    return;
  }

  const preloaderDiv = document.getElementById("tableauPreloader");
  const host = placeholderDiv.getAttribute('data-host');
  const url = placeholderDiv.getAttribute('data-url');
  const filter_options = placeholderDiv.getAttribute('data-options');
  const section = placeholderDiv.getAttribute('data-section');
  const options = {
    hideTabs: true,
    hideToolbar: true,
    toolbarPosition: 'top',
    device: 'desktop',
    onFirstInteractive: () => {
      window.workbook = viz.getWorkbook();
      window.activeSheet = workbook.getActiveSheet();
      window.dashboardFiltersStorage = {
        'username': '',
        'workbook': {
          'name': window.workbook.getName(),
          'url': window.activeSheet.getUrl(),
          'sheet': window.activeSheet.getName()
        },
      };

      workbook.getParametersAsync().then(parameters => {
        parameters.forEach(parameter => {
          window.dashboardFiltersStorage[parameter.getName()] = parameter.getCurrentValue().formattedValue;
        });

        localforage.config({
          name: section
        });

        // MERGE FILTERS WITH EXISTING LOCALFORAGE VALUES
        localforage.getItem('filters', (err, value) => {
          window.dashboardFiltersStorage = {
            ...window.dashboardFiltersStorage,
            ...value,
            ...JSON.parse(filter_options)
          };
        }).then(() => {
          localforage.setItem('filters', convertDates(window.dashboardFiltersStorage));
        });

        // FILTER_CHANGE
        viz.addEventListener(tableauSoftware.TableauEventName.FILTER_CHANGE, event => {
          event.getFilterAsync().then(filter => {
            localforage.getItem('filters', function (err, value) {
              window.dashboardFiltersStorage = value;
            }).then(() => {
              window.dashboardFiltersStorage[filter.getFieldName()] = filter.getIsAllSelected() ?
                'all' :
                filter.getAppliedValues().map(val => val.value)[0];
              localforage.setItem('filters', convertDates(dashboardFiltersStorage));
            });
          });
        });

        // PARAMETER_VALUE_CHANGE
        viz.addEventListener(tableauSoftware.TableauEventName.PARAMETER_VALUE_CHANGE, event => {
          event.getParameterAsync().then(parameter => {
            localforage.getItem('filters', function (err, value) {
              window.dashboardFiltersStorage = value;
            }).then(() => {
              window.dashboardFiltersStorage[parameter.getName()] = parameter.getCurrentValue().formattedValue;
              localforage.setItem('filters', convertDates(dashboardFiltersStorage));
            });
          });
        });

        // MARKS_SELECTION
        viz.addEventListener(tableauSoftware.TableauEventName.MARKS_SELECTION, event => {
          event.getWorksheet().getSelectedMarksAsync().then(marks => {
            let values = [];
            localforage.getItem('filters', function (err, value) {
              window.dashboardFiltersStorage = value;
            }).then(() => {
              marks.forEach(mark => {
                mark.getPairs().forEach(pair => {
                  if (pair.fieldName === 'Référence' || pair.fieldName === 'ref_id_produit') {
                    values.push(pair.value)
                  }
                });
              });
              window.dashboardFiltersStorage['references'] = values;
              localforage.setItem('filters', convertDates(dashboardFiltersStorage));
            });
          });
        });

      });

      handleActionButtons();
      if (preloaderDiv !== null) {
        preloaderDiv.parentNode.removeChild(preloaderDiv);
        placeholderDiv.style.display = 'block';
      }
    },
    ...JSON.parse(filter_options),
  };

  const initViz = () => {
    try {
      let path = url.split('views', -1)[1];

      window.viz = new tableau.Viz(placeholderDiv, url, options);
    } catch (e) {
      console.error(e);
      toastr.error('tableau.Viz error : ' + e._message + ' - dashboard : '.path);
    }
  };

  const loadScript = (callback) => {
    const script = document.createElement('script');
    script.src = `https://${host}/javascripts/api/tableau-2.9.1.min.js`;
    script.id = 'tableauApi';
    document.body.appendChild(script);
    script.onload = () => {
      callback();
    };
  };

  const onToolbarStateChange = (toolbarEvent) => {
    let toolbarState = toolbarEvent.getToolbarState();
    updateToolbarState(toolbarState);
  }

  const handleActionButtons = () => {

    let $tableauCard = jQuery('#tableauCard');
    $tableauCard.on('minimized.lte.cardwidget', tableauCardEvent);
    $tableauCard.on('maximized.lte.cardwidget', tableauCardEvent);
    document.getElementById('card-header').style.display = 'block';
    document.getElementById('btn-refresh').onclick = refreshData;
  };

  const tableauCardEvent = (e) => {
    jQuery('#tableauViz').toggleClass(['offset-md-1']);
  }

  // Refresh the Data
  const refreshData = () => {
    viz.refreshDataAsync();
  }

  // Restores the workbook to its starting state
  const revertAll = () => {
    workbook.revertAllAsync();
  }

  // Opens the Download to PDF dialog box
  const exportToPDF = () => {
    viz.showExportPDFDialog();
  }

  // Opens the Download Crosstab dialog box
  const exportToCSV = () => {
    localforage.getItem('filters').then(f => {
      f.title = document.title;
      f.workbook = {
        "name":window.workbook.getName(),
        "url":window.activeSheet.getUrl(),
        "sheet":window.activeSheet.getName()
      };
      const preloader = document.getElementById('exportPreloader');
      const exportBtn = document.getElementById('btn-export-to-csv');
      preloader.classList.remove('d-none');
      exportBtn.classList.add('disabled');
      exportBtn.disabled = true;
      jQuery.ajax({
        type: 'POST',
        url: '/insights/request/extract',
        dataType: "json",
        headers: {
          'X-CSRF-TOKEN': jQuery('meta[name="csrf-token"]').attr('content')
        },
        data: {
          'data': f
        },
        success: function () {
          return toastr.success('Votre export est désormais disponible dans l\'onglet téléchargements.');
        },
        error: function(xhr, status, error) {
          return toastr.error(xhr.responseJSON);
        },
        complete: function () {
          preloader.classList.add('d-none');
          exportBtn.classList.remove('disabled');
        }
      });
    });
  }

  // Opens the Download Image dialog box
  const exportImage = () => {
    viz.showExportImageDialog();
  }

  /**
   * Sort Object and convert dates to DD/MM/YYYY
   *
   * @param obj
   * @returns {string}
   */
  const convertDates = obj => {
    return Object.keys(obj)
        .sort()
        .reduce((result, key) => {
          if (key.includes('Date') && obj[key].includes('-')) {
            result[key] = window.moment(obj[key], 'YYYY-MM-DD').format('DD/MM/YYYY')
          } else {
            result[key] = obj[key];
          }
          return result;
        }, {});
  };

  loadScript(() => {
    initViz();
  });

  window.convertDates = convertDates;

})();
